function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M23.995 5.401a5.497 5.497 0 00-10.354-2.475H.5a.5.5 0 00-.5.5v20a.5.5 0 00.5.5h23a.5.5 0 00.5-.5v-18c0-.009-.005-.016-.005-.025zM13 8.926h1.202A5.462 5.462 0 0020 10.786v2.14h-7zm-4-5h4.232a5.457 5.457 0 00.338 4H9zm3 5v4H5v-4zm-11-5h7v4H1zm0 5h3v4H1zm0 5h6v4H1zm9 9H1v-4h9zm-2-5v-4h8v4zm11 5h-8v-4h8zm4 0h-3v-4h3zm0-5h-6v-4h6zm0-5h-2v-2.534a5.523 5.523 0 001.795-1.466H23zm-.72-5a4.495 4.495 0 01-.893 1A4.506 4.506 0 0121 9.24a4.482 4.482 0 01-1 .484 4.351 4.351 0 01-4.387-.798A4.435 4.435 0 0114 5.5a4.465 4.465 0 01.299-1.574 4.48 4.48 0 018.39-.038 4.4 4.4 0 01-.409 4.038z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.805 8.024a1.12 1.12 0 01-.676-.227 3.51 3.51 0 01-.113-.097l-1.254-1.255a.5.5 0 01.707-.707l1.25 1.25a.146.146 0 00.19-.014l2.42-3.227a.5.5 0 01.8.6l-2.421 3.227a1.12 1.12 0 01-.744.439 1.09 1.09 0 01-.16.01z"
});

function SvgBuildSuccess(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "buildSuccess.cf5e4.svg";
export { SvgBuildSuccess as ReactComponent };